import { render, staticRenderFns } from "./estate-section.vue?vue&type=template&id=9a56e882&"
import script from "./estate-section.vue?vue&type=script&lang=js&"
export * from "./estate-section.vue?vue&type=script&lang=js&"
import style0 from "./estate-section.vue?vue&type=style&index=0&id=9a56e882&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports